/* eslint-disable prettier/prettier */
export const emojiIconMap: Record<string, string> = {
  'File Info': '🗂️',
  'General Info': '📄',
  Cedant: '🧑‍💼',
  Cedants: '🧑‍💼',
  Broker: '🤝',
  Brokers: '🤝',
  Signatures: '✍️',

  'QUOTA SHARE - Proportional': '📊',
  'SURPLUS - Proportional': '💹',

  'EXCESS OF LOSS - Non Proportional': '🚧',
  'STOP LOSS - Non Proportional': '🛑',

  Layers: '📚',
  Sublayers: '📚',
  Sublayer: '📚',

  Installments: '💸',
  Installment: '💵',

  Reinstatements: '♻️',
  Reinstatement: '♻️',
  Adjustments: '🛠️',
  Adjustment: '🛠️',
};
